import { Injectable, Injector } from '@angular/core';
import { GenericApiService } from 'shared/services/index';
import { DeviceModelComplexModel, DeviceModelFileModel, DeviceModelModel, DeviceModelSpareModel } from '../definition';

@Injectable({
  providedIn: 'root'
})

export class DeviceModelService extends GenericApiService<DeviceModelModel, any> {

  constructor(injector: Injector) {
      super(injector, 'devicemodel');
  }
  createComplex(request: DeviceModelComplexModel) {
    return this.httpClient.post<DeviceModelComplexModel>(this.apiUrl + '/complex', request);
  }

  updateComlex(request: DeviceModelComplexModel) {
    return this.httpClient.put<DeviceModelComplexModel>(this.apiUrl + '/complex', request);
  }

  getComlex(id: string) {
    return this.httpClient.get<DeviceModelComplexModel>(this.apiUrl + `/complex/${id}`);
  }

  getAttachmentFiles(id: string) {
    return this.httpClient.get<DeviceModelFileModel[]>(this.apiUrl + `/${id}/AttachmentFiles`);
  }

  getSpareListById(id: string) {
    return this.httpClient.get<DeviceModelSpareModel[]>(this.apiUrl + `/${id}/DeviceModelSpares`);
  }
}
